import '../../css/pages/kitbuilder.scss';
import { createStateManager, DEFAULTS } from "../modules/state-manager/state-manager";
import * as CTH from "../modules/css-transition-helper/css-transition-helper";

const init = async () => {
    console.log('Kit Builder init');
    tabToggle();
    handleCategoryClick(document.querySelector(`.kit-builder__tab[data-step="1"]`) as HTMLElement);
    clearKit();
    getAccessories();
};

const handleCategoryClick = (container: HTMLElement) => {
    const links = container.querySelectorAll('.js-get-kit-data') as NodeListOf<HTMLLinkElement>;
    if (links) {
        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                links.forEach((linkk) => {
                    linkk.classList.remove('selected');
                });
                const url = link.getAttribute('href') as string;
                const step = parseInt(link.dataset.step);
                fetch(url)
                    .then((resp) => resp.text())
                    .then((html) => {
                        if (html) {
                            appendContent(html, step + 1);
                            handleStepClick(step + 1);
                        }
                        link.classList.add('selected');
                    })
                    .catch(function (err) {
                        console.warn('Something went wrong.', err);
                    });
            });
        });
    }
};

const appendContent = (html: string, step: number = 0) => {
    const nextStep = document.querySelector(`.kit-builder__tab[data-step="${step}"]`) as HTMLDivElement;
    const container = nextStep.querySelector(`.kit-builder__tab-content`) as HTMLDivElement;
    container.innerHTML = html;
};

const handleStepClick = (step: number) => {
    const nextStep = document.querySelector(`.kit-builder__tab[data-step="${step}"]`) as HTMLDivElement;
    const container = nextStep.querySelector(`.kit-builder__tab-content`) as HTMLDivElement;
    nextStep.classList.remove('disabled');
    if (step < 4) nextStep.click();
    setTimeout(() => {
        if (step == 2) handleCategoryClick(container);
        if (step > 2) {
            addToKit(container);
            addedItemsCheck(container);
            removeFromKit(container);
        }
    }, 500);
};

const tabToggle = () => {
    const tabs = document.querySelectorAll('.kit-builder__tab') as NodeListOf<HTMLUListElement>;
    tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
            tabs.forEach((taab) => {
                taab.classList.remove('is-visible');
                taab.querySelector('.kit-builder__tab-content').classList.remove('is-active', 'is-visible');
            });
            tab.querySelector('.kit-builder__tab-content').classList.add('is-visible', 'is-active');
            tab.classList.add('is-visible');
        });
    });
};

const addToKit = (context: any = document) => {
    const buttons = context.querySelectorAll('.js-add-to-kit') as NodeListOf<HTMLButtonElement>;
    buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            let formData = new FormData();
            formData.append('productId', button.dataset.id);
            fetch(`/kitbuilder/kitbuilder/add`, {
                method: 'POST',
                body: formData
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) {
                        const total = data.total;
                        const saving = data.saving;
                        button.innerText = 'In Your Kit';
                        button.classList.add('disabled');
                        const productBottom = button.parentElement.previousElementSibling as HTMLElement;
                        productBottom.classList.add('added');
                        toggleSummary(data.products.length, total, saving);
                    } else console.log(data.errors);
                })
                .catch(function (err) {
                    console.warn('Something went wrong.', err);
                });
        });
    });
};

const toggleSummary = (kitCount: number, total: number, saving: number) => {
    const kitSummary = document.querySelector('.kit-summary') as HTMLElement;
    const kitTotal = document.getElementById('kitTotal') as HTMLElement;
    const step4 = document.querySelector(`.kit-builder__tab[data-step="4"]`) as HTMLDivElement;
    if (kitCount > 0) {
        updateKitCount(kitCount);
        kitTotal.innerText = 'Total: £' + total.toString();
        toggleSavings(saving);
        kitSummary.classList.remove('d-none');
        step4.classList.remove('disabled');
    } else {
        kitSummary.classList.add('d-none');
        step4.classList.add('disabled');
        const bottom = document.querySelectorAll('.product-grid .associated-product .associated-product__bottom') as NodeListOf<HTMLElement>;
        bottom.forEach(elm => { elm.classList.remove('added'); })
    }
};

const updateKitCount = (count: number) => {
    const kitCount = document.getElementById('kitCount') as HTMLElement;
    kitCount.innerText = count.toString();
};

const toggleSavings = (saving: number) => {
    const savingElems = document.querySelectorAll('.kit-pricing save') as NodeListOf<HTMLElement>;
    const kitSaving = document.getElementById('kitSaving') as HTMLElement;
    if (saving > 0) {
        kitSaving.innerText = '£' + saving.toString();
        savingElems.forEach((elem) => {
            elem.classList.remove('d-none');
        });
    } else
        savingElems.forEach((elem) => {
            elem.classList.add('d-none');
        });
};

const addedItemsCheck = (context: any = document) => {
    fetch(`/kitbuilder/kitbuilder/get`)
        .then((resp) => resp.json())
        .then((data) => {
            const kitCount = data.products.length;
            if (kitCount > 0) {
                const total = data.total;
                const saving = data.saving;
                toggleSummary(kitCount, total, saving);
                const buttons = context.querySelectorAll('.js-add-to-kit') as NodeListOf<HTMLButtonElement>;
                buttons.forEach((button) => {
                    const productId = button.dataset.id;
                    data.products.forEach((product) => {
                        if (product.productId === parseInt(productId)) {
                            button.innerText = 'In Your Kit';
                            button.classList.add('disabled');
                            const productBottom = button.parentElement.previousElementSibling as HTMLElement;
                            productBottom.classList.add('added');
                        }
                    });
                });
            } else toggleSummary(0, 0, 0);
        })
        .catch(function (err) {
            console.log('Something went wrong.', err);
        });
};

const clearKit = () => {
    const button = document.querySelector('.js-clear-kit') as HTMLButtonElement;
    button.addEventListener('click', (e) => {
        e.preventDefault();
        fetch(`/kitbuilder/kitbuilder/clear`)
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    toggleSummary(0, 0, 0);
                    const buttons = document.querySelectorAll('.js-add-to-kit.disabled') as NodeListOf<HTMLButtonElement>;
                    buttons.forEach((button) => {
                        button.innerText = 'Add To Kit';
                        button.classList.remove('disabled');
                    });
                    const step3 = document.querySelector(`.kit-builder__tab[data-step="3"]`) as HTMLDivElement;
                    const step4 = document.querySelector(`.kit-builder__tab[data-step="4"]`) as HTMLDivElement;
                    step3.click();
                    step4.classList.add('disabled');
                } else console.log(data.errors);
            })
            .catch(function (err) {
                console.warn('Something went wrong.', err);
            });
    });
};

const getAccessories = (IDs: string = '') => {
    const step4 = document.querySelector(`.kit-builder__tab[data-step="4"] .js-show-kit-step`) as HTMLDivElement;
    const container = document.querySelector(
        `.kit-builder__tab[data-step="4"] .kit-builder__tab-content`
    ) as HTMLDivElement;
    step4.addEventListener('click', (e) => {
        e.preventDefault();
        fetch(`/kitbuilder/kitbuilder/get`)
            .then((resp) => resp.json())
            .then((data) => {
                const kitCount = data.products.length;
                if (kitCount > 0) {
                    const IDs = data.products.map((item) => item.productId).join(',');
                    fetch(`/kitbuilder/kitbuilder/accessories?productIds=${IDs}`)
                        .then((resp) => resp.text())
                        .then((html) => {
                            if (html) {
                                appendContent(html, 4);
                                setTimeout(() => {
                                    addToKit(container);
                                    addedItemsCheck(container);
                                }, 500);
                            }
                        })
                        .catch(function (err) {
                            console.warn('Something went wrong.', err);
                        });
                }
            })
            .catch(function (err) {
                console.log('Something went wrong.', err);
            });
    });
};

export const addToBasket = () => {
    const button = document.querySelector('.js-add-all-to-kit') as HTMLButtonElement;
    button?.addEventListener('click', (e) => {
        e.preventDefault();
        fetch(`/kitbuilder/kitbuilder/addToBasket`)
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) location.href = '/basket';
                else {
                    const errors = data.errors;
                    const errorBox = document.querySelector('.card--quick-basket .alert-danger') as HTMLElement;
                    errorBox.innerHTML = '';
                    errors.forEach((error) => {
                        errorBox.innerHTML += `<span>${error}</span><br />`;
                    });
                    errorBox.classList.remove('hidden');
                }
            })
            .catch(function (err) {
                console.warn('Something went wrong.', err);
            });
    });
};

export const removeFromKit = (context: any = document) => {
    const removeButtons = context.querySelectorAll('.js-remove-from-kit') as NodeListOf<HTMLButtonElement>;
    removeButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const productId = button.dataset.id;
            let formData = new FormData();
            formData.append('productId', productId);
            fetch(`/kitbuilder/kitbuilder/delete`, {
                method: 'POST',
                body: formData
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) {
                        const total = data.total;
                        const saving = data.saving;
                        const kitCount = data.products.length;
                        toggleSummary(kitCount, total, saving);
                        const productBottom = button.parentElement as HTMLElement;
                        productBottom.classList.remove('added');
                        const addToKitButton = button.parentElement.nextElementSibling.querySelector('.btn') as HTMLElement;
                        addToKitButton.innerText = 'Add To Kit';
                        addToKitButton.classList.remove('disabled');
                        if (button.closest('.card--quick-basket')) {
                            button.closest('.associated-product').remove();
                            const gridButton = document.querySelector(`.product-grid .js-add-to-kit[data-id="${button.dataset.id}"]`) as HTMLButtonElement;
                            gridButton.innerText = 'Add To Kit';
                            gridButton.classList.remove('disabled');
                            gridButton.parentElement.previousElementSibling.classList.remove('added');
                            if (data.products.length == 0) document.querySelector<HTMLElement>('.js-close-off-canvas-panel')?.click();
                        }
                    } else alert('something wrong');
                })
                .catch(function (err) {
                    console.warn('Something went wrong.', err);
                });
        });
    });
};

const exit = () => {
    console.log('Kit Builder: Exit');
};

window.kitbuilder = {
    init,
    exit
};